<template>
  <e-collapse title="字段配置" :expand="true">
    <t-form-item :label="item.name" v-for="(item, index) in data" :key="index">
      <t-select v-model="item.value" size="small" filterable :placeholder="`请选择${item.name}`" clearable :style="{width: item?.delete ? '85%' : '100%'}">
        <t-option v-for="(ele, eindex) in dataSetData" :key="eindex" :label="ele.COLUMN_NAME" 
          :value="ele.COLUMN_NAME" />
      </t-select>
      <template v-if="item?.delete">
        <DeleteIcon size="16px" style="color:red;margin: 0 5px;cursor: pointer;" @click="onDelete(index)" />
      </template>
    </t-form-item>
    <slot></slot>

    <!-- <t-form-item>
      <t-button size="small" @click="choiceDataset">选择数据集</t-button>
    </t-form-item>  -->
  </e-collapse>
</template>
<script>
import { getDetailApi } from "@/api/dataset/dataset-sql";
import { executeSelectKey } from "@/api/sql-execute-api";
import {
  DeleteIcon
} from 'tdesign-icons-vue-next';
export default {
  name: "cpt-data",
  components: { DeleteIcon },
  data() {
    return {
      dataSetData: [],
    };
  },
  props: {
    data: Array,
    cptDataForm: Object,
  },
  mounted() {
    // console.log(this.cptDataForm,'cptDataForm');
    if (this.cptDataForm && this.cptDataForm.dataSource &&
      String(this.cptDataForm.dataSource) === '4') {
      this.executeSelectFun(this.cptDataForm);
    }
  },
  //   watch: {
  //   'cptDataForm': {
  //     handler(obj) {
  //       //  console.log(obj,'obj')
  //     },
  //     deep: true,
  //   },
  // },
  created() { },
  methods: {
    executeSelectFun(cptDataForm) {
      const that = this;
      getDetailApi(cptDataForm.datasetId)
        .then((res) => {
          // console.log(res,'res')
          let iptstr = res.data.sqlText;
          if (!iptstr) {
            // this.$message.Message.error("SQL不能为空");
            return [];
          }
          // 返回 executeSelectKey 的 Promise 并直接在其 then 中处理结果
          return executeSelectKey({
            sql: iptstr,
            datasourceId: res.data.datasourceId,
            isArray: true,
          });
        })
        .then((result) => {
          // console.log(result, "result");

          // 直接根据 result 数据结构来决定是否赋值以及如何赋值
          if (result && result.data) {
            that.dataSetData = result.data || [];
            cptDataForm.dataSetData = that.dataSetData
          } else {
            that.dataSetData = [];
          }
        })
        .catch((error) => {
          // this.$message.error("查询数据失败，请稍后重试");
          that.dataSetData = []; // 当出现错误时，清空或设置为空数组
        });
    },
    choiceDataset() {
      this.$refs["dataset-dialog"].opened(this.currentCpt.cptOption.cptDataForm.datasetId)
    },
    onDelete(index) {
      this.data.splice(index, 1)
    }
  },
};
</script>